export default class I18n {
    constructor (lib) {
        this.lib = lib || {};
    }

    get lang () {
        const langAttr = document.documentElement.lang;
        const regex = /^(it|en|de|fr).*?/iug;
        const match = langAttr.match(regex);
        const lang = match && match.length && match[0].toLowerCase().split('-')[0];

        return lang || 'it';
    }

    get (key) {
        const lang = this.lang;
        const currLib = this.lib[lang];

        return currLib && key && currLib[key] ? currLib[key] : key;
    }
}
